import truckerValidationSchema from './Steps/Trucker/validation';
import compositionsValidationSchema from './Steps/Compositions/validation';
import travelValidationSchema from './Steps/Travel/validation';
import partnerValidationSchema from './Steps/Partner/validation';

const steps = [truckerValidationSchema, compositionsValidationSchema, travelValidationSchema, partnerValidationSchema];

export const useValidate = () => (step: number) => steps[step - 1];
